const getUrlParameter = (name) => {
    name = name.replace(/\[/, '\\[').replace(/]/, '\\]');

    let container = {};
    window.location.search.split('&').toString().slice(1).split(",").forEach(item => {
        container[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]) ? item.split("=")[1] : "No query strings available";
    });

    if (container?.[name]) {
        return container[name];
    } else {
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
};

export default getUrlParameter;
